import { useCallback, useState } from 'react';
import { FlatList, Pressable, RefreshControl, Text } from 'react-native';
import { useFocusEffect, useRouter } from 'expo-router';
import { useAuth } from '../context/AuthContext';
import { listTaskReports, TaskReport } from '../api/admin';
import { Card, EmptyState, ErrorText, ScreenContainer } from '../components/ui';
import { colors, fonts } from '../theme';
import { ApiError } from '../api/client';

export default function AdminReportsScreen() {
  const { token } = useAuth();
  const router = useRouter();
  const [reports, setReports] = useState<TaskReport[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      setReports(await listTaskReports(token));
      setLoadError(null);
    } catch (e) {
      setLoadError(e instanceof ApiError ? e.message : 'Không tải được danh sách báo cáo, vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useFocusEffect(
    useCallback(() => {
      load();
    }, [load]),
  );

  return (
    <ScreenContainer safeTop safeBottom>
      {loadError ? <ErrorText>{loadError}</ErrorText> : null}
      <FlatList
        data={reports}
        keyExtractor={(item) => item.id}
        refreshControl={<RefreshControl refreshing={loading} onRefresh={load} />}
        ListEmptyComponent={!loading && !loadError ? <EmptyState text="Chưa có báo cáo nhiệm vụ đáng ngờ nào" /> : null}
        renderItem={({ item }) => (
          <Pressable onPress={() => item.taskId && router.push(`/task/${item.taskId}`)}>
            <Card>
              <Text style={{ fontSize: 16, fontFamily: fonts.bold, color: colors.text }}>
                {item.task?.title ?? 'Nhiệm vụ'}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 2 }}>
                Shop: {item.task?.shop?.name ?? '—'}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 2 }}>
                Người báo cáo: {item.reporter?.name ?? item.reporterId}
              </Text>
              <Text style={{ color: colors.text, marginTop: 6, fontSize: 13 }}>{item.reason}</Text>
              <Text style={{ color: colors.textMuted, marginTop: 4, fontSize: 11 }}>
                {new Date(item.createdAt).toLocaleString('vi-VN')}
              </Text>
            </Card>
          </Pressable>
        )}
      />
    </ScreenContainer>
  );
}
